import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface SearchFormProps {
  faxStatusList: any;
  getFax(params: GetFaxes): any;
  isFetchingFaxes: boolean;
  newTableDataHandler: any;
  onTableChange: {
    current?: number
    defaultPageSize?: number
    pageSize?: number
    position?: Array<string>
    showSizeChanger?: boolean
    total?: number
  };
  providerList: any;
  setCollapseState(state: any[]): any
}

export interface GetFaxes {
  AuthNo: string,
  CompanyId: string | null,
  DOB: string | null,
  FaxDate: string | null,
  FaxStatus: string | null,
  FirstName: string,
  LastName: string,
  MembId: string,
  PageIndex: number,
  PageSize: number,
  ProvKeyId: string | null,
  Provider: Object,
  Status: string | null,
  UserId: string,
  index: number,
}

export interface GetResponse {
    RmiAuthNo: string
    RmiCompanyId: string
    RmiCount: number
    RmiFileDate: string
    RmiFileId: number
    RmiFileLocation: string
    RmiFileName: string
    RmiFileSize: number
    RmiSubmitStatus: string
}

export interface FaxStatusList {
  RmiActiveRec: string
  RmiCompanyId: string
  RmiCreatedBy: string
  RmiCreatedDate: string
  RmiDescr: string
  RmiLetterTypeCode: string
  RmiModifiedBy: string
  RmiModifiedDate: string
  RmiType: string
}

export const get = (params: GetFaxes) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_FAXES_REQUEST });

  return api.authorization.faxes.get(params)
    .then((res: any) => {

      dispatch({
        type: types.GET_FAXES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, err.message, 'Post failed!');
      const errors = _get(err, 'response.data.errors', {}); //TODO
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_FAXES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getStatus = () => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_FAX_STATUS_REQUEST });

  return api.authorization.faxes.getStatus()
    .then((res: any) => {

      dispatch({
        type: types.GET_FAX_STATUS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, err.message, 'Get failed!');
      const errors = _get(err, 'response.data.errors', {}); //TODO
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_FAX_STATUS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
